import React from 'react';

export const WPS_LOGO = () => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 100 85'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M93.4575 47.8179C96.5191 49.7861 96.5191 54.2615 93.4575 56.2297L52.7038 82.4285C51.0568 83.4873 48.9433 83.4873 47.2962 82.4285L6.5425 56.2297C3.48088 54.2615 3.48088 49.7861 6.5425 47.8179L47.2962 21.6191C48.9432 20.5603 51.0568 20.5603 52.7038 21.6191L93.4575 47.8179Z'
      fill='#77CBFA'
    />
    <path
      d='M93.4575 28.7703C96.5191 30.7385 96.5191 35.2139 93.4575 37.1821L52.7038 63.3809C51.0568 64.4397 48.9433 64.4397 47.2962 63.3809L6.5425 37.1821C3.48088 35.2139 3.48088 30.7385 6.5425 28.7703L47.2962 2.57146C48.9432 1.51265 51.0568 1.51265 52.7038 2.57146L93.4575 28.7703Z'
      fill='url(#paint0_linear)'
    />
    <defs>
      <linearGradient
        id='paint0_linear'
        x1='102.579'
        y1='32.9762'
        x2='-6.70645e-07'
        y2='32.9762'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4659FF' />
        <stop offset='1' stopColor='#46A6FF' />
      </linearGradient>
    </defs>
  </svg>
);

export const WPS_LOGO_FULL = ({ inverted }) => (
  // Inverted value to ture to get black text. False is white text
  <svg
    xmlns='http://www.w3.org/2000/svg'
    className='logo-full'
    width='100%'
    height='100%'
    fill='none'
    viewBox='0 0 292 83'>
    <path
      fill='#77CBFA'
      d='M89.457 46.985c3.062 1.968 3.062 6.443 0 8.411l-40.753 26.2a5 5 0 01-5.408 0l-40.754-26.2c-3.061-1.968-3.061-6.443 0-8.411l40.754-26.2a5 5 0 015.408 0l40.753 26.2z'></path>
    <path
      fill='url(#paint0_linear)'
      d='M89.457 27.937c3.062 1.968 3.062 6.444 0 8.412L48.704 62.548a5 5 0 01-5.408 0l-40.754-26.2c-3.061-1.967-3.061-6.443 0-8.411L43.296 1.738a5 5 0 015.408 0l40.753 26.199z'></path>
    <path
      fill={inverted ? '#000' : '#fff'}
      d='M139.133 51.356c1.995 0 3.407-.195 4.234-.584.827-.39 1.241-1.144 1.241-2.263 0-.876-.535-1.63-1.606-2.263-1.071-.682-2.701-1.436-4.891-2.263a54.106 54.106 0 01-4.672-1.971c-1.363-.682-2.531-1.485-3.504-2.41a10.283 10.283 0 01-2.263-3.43c-.535-1.314-.803-2.896-.803-4.745 0-3.602 1.338-6.449 4.015-8.541 2.677-2.093 6.351-3.14 11.023-3.14 2.336 0 4.575.22 6.716.658 2.141.389 3.845.827 5.11 1.314l-1.898 8.468a38.96 38.96 0 00-4.161-1.168c-1.46-.341-3.115-.511-4.964-.511-3.407 0-5.11.949-5.11 2.847 0 .438.073.827.219 1.168.146.34.438.681.876 1.022a21.51 21.51 0 001.752 1.022c.779.34 1.752.73 2.92 1.168 2.385.876 4.356 1.752 5.913 2.628 1.557.827 2.774 1.752 3.65 2.774.925.973 1.557 2.068 1.898 3.285.389 1.216.584 2.628.584 4.234 0 3.796-1.436 6.667-4.307 8.614-2.823 1.946-6.838 2.92-12.045 2.92-3.407 0-6.254-.292-8.541-.876-2.239-.584-3.796-1.071-4.672-1.46l1.825-8.833a38.48 38.48 0 005.694 1.752c1.947.389 3.869.584 5.767.584zM163.176 11.206l10.877-1.752v11.315h13.067v9.052h-13.067v13.505c0 2.287.389 4.112 1.168 5.475.827 1.362 2.457 2.044 4.891 2.044 1.168 0 2.36-.098 3.577-.292a20.57 20.57 0 003.431-.95l1.533 8.469a30.96 30.96 0 01-4.38 1.387c-1.606.389-3.577.584-5.913.584-2.969 0-5.427-.39-7.373-1.168-1.947-.828-3.504-1.947-4.672-3.358-1.168-1.46-1.996-3.212-2.482-5.256-.438-2.044-.657-4.307-.657-6.79V11.207zM209.224 51.575c1.071 0 2.093-.025 3.066-.073.974-.049 1.752-.122 2.336-.22v-8.248c-.438-.098-1.095-.195-1.971-.292a21.934 21.934 0 00-2.409-.146c-1.022 0-1.995.073-2.92.219-.876.097-1.654.316-2.336.657-.681.34-1.216.803-1.606 1.387-.389.584-.584 1.314-.584 2.19 0 1.703.56 2.895 1.679 3.577 1.168.632 2.75.949 4.745.949zm-.876-31.828c3.212 0 5.889.365 8.03 1.095 2.142.73 3.845 1.776 5.11 3.139 1.314 1.362 2.239 3.017 2.774 4.964.536 1.946.803 4.112.803 6.497v22.63c-1.557.34-3.723.73-6.497 1.168-2.774.486-6.132.73-10.074.73-2.482 0-4.745-.22-6.789-.657-1.995-.438-3.723-1.144-5.183-2.117a10.132 10.132 0 01-3.358-3.942c-.778-1.606-1.168-3.577-1.168-5.913 0-2.239.438-4.137 1.314-5.694a10.705 10.705 0 013.65-3.723c1.509-.925 3.237-1.582 5.183-1.971a27.528 27.528 0 016.059-.657c1.412 0 2.653.073 3.723.219 1.12.097 2.02.243 2.701.438V34.93c0-1.85-.559-3.334-1.679-4.453-1.119-1.12-3.066-1.68-5.84-1.68-1.849 0-3.674.147-5.475.439-1.8.243-3.358.608-4.672 1.095l-1.387-8.76c.633-.195 1.412-.39 2.336-.584a27.79 27.79 0 013.139-.584c1.12-.195 2.288-.341 3.504-.438a33.103 33.103 0 013.796-.22zM244.172 40.26c0 6.959 2.579 10.439 7.738 10.439 1.119 0 2.214-.146 3.285-.438 1.119-.292 2.02-.657 2.701-1.095V29.529a17.514 17.514 0 00-2.044-.22 23.182 23.182 0 00-2.701-.145c-2.969 0-5.207 1.022-6.716 3.066-1.509 1.995-2.263 4.672-2.263 8.03zm-11.096-.292c0-2.969.438-5.67 1.314-8.103.925-2.482 2.239-4.6 3.942-6.351 1.703-1.801 3.796-3.188 6.278-4.161 2.482-.974 5.305-1.46 8.468-1.46 1.314 0 2.677.073 4.088.219 1.46.097 2.871.243 4.234.438 1.411.194 2.75.438 4.015.73 1.265.243 2.385.51 3.358.803v50.589h-10.877V58.218a20.388 20.388 0 01-3.796 1.24c-1.314.293-2.725.439-4.234.439-5.451 0-9.612-1.777-12.483-5.33-2.871-3.6-4.307-8.467-4.307-14.6z'></path>
    <path
      fill='#46A6FF'
      d='M278 49.167a4 4 0 014-4h6a4 4 0 014 4v6a4 4 0 01-4 4h-6a4 4 0 01-4-4v-6z'></path>
    <defs>
      <linearGradient
        id='paint0_linear'
        x1='98.579'
        x2='-4'
        y1='32.143'
        y2='32.143'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4659FF'></stop>
        <stop offset='1' stopColor='#46A6FF'></stop>
      </linearGradient>
    </defs>
  </svg>
);
